<template>
	<button v-if="!this.button.disabled" :disabled="!!this.button.disabled" class="btnCustomIconButton" type="button" @click="onCustomIconButton">
		<svg-sprite :style="`color: ${color}`" :width="width" :height="height" :icon-id="icon"></svg-sprite>
	</button>
</template>

<script>

export default {
	name: "FieldCustomIconButton",
	props: {
		button: Object,
		item: Object,
	},
	data() {
		return {
			isDisabled: null,
			color: null,
			width: null,
			height: null,
			icon: null,
		};
	},
	methods: {
		onCustomIconButton() {
			if (!this.isDisabled) this.$emit('updateCustomIconButton', this.icon);
		},
	},
	mounted() {
		if (this.button) {
			const { color, width, height, icon } = this.button;
			this.color = color ? color : 'inherit';
			this.width = width ? width : 20;
			this.height = height ? height : 20;
			this.icon = icon;
		}
	}
};
</script>

<style scoped lang="scss"></style>
